/**
 * statusColor takes a string and returns a color identification for UI border
 * @param status string to check color against
 * @returns a string
 */
export const statusColor = (
  status: string,
): 'green' | 'orange' | 'red' | 'blue' | 'custom' => {
  let color;

  switch (status.toLowerCase()) {
    case 'active':
      color = 'green';
      break;
    case 'pre-prod':
      color = 'orange';
      break;
    case 'retired':
      color = 'red';
      break;
    default:
      color = 'empty';
  }

  return color as 'green' | 'orange' | 'red' | 'blue' | 'custom';
};
